import React__default from 'react';
import classnames from 'classnames';

const Discount = ({ className , discount , isWide =false , label  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames('product-block-discount', className)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "product-block-discount__value"
    }, discount), label && /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('product-block-discount__label', {
            'product-block-discount__label--wide': isWide
        })
    }, label))
;

export { Discount };
//# sourceMappingURL=Discount.js.map
